import React, { Component, Fragment } from "react";
import { Row, Card, CardBody, CardSubtitle } from "reactstrap";
import { Colxx, Separator } from "../../../components/common/CustomBootstrap";
import Breadcrumb from "../../../containers/navs/Breadcrumb";

export default class libraries extends Component {
  render() {
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb heading="menu.libraries" match={this.props.match} />
            <Separator className="mb-5" />
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card>
              <CardBody>

                <CardSubtitle><b>Bootstrap</b></CardSubtitle>
                <p>
                  The most popular HTML, CSS, and JavaScript framework for developing responsive, mobile first projects on the web.
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="http://www.getbootstrap.com">http://www.getbootstrap.com</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>jQuery</b></CardSubtitle>
                <p>
                  The Write Less, Do More, JavaScript Library.
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://jquery.com">https://jquery.com</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>BaguetteBox</b></CardSubtitle>
                <p>
                  Simple and easy to use lightbox script written in pure JavaScript
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://github.com/feimosi/baguetteBox.js">https://github.com/feimosi/baguetteBox.js</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>Bootstrap Datepicker</b></CardSubtitle>
                <p>
                  A datepicker for twitter bootstrap
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://github.com/uxsolutions/bootstrap-datepicker">https://github.com/uxsolutions/bootstrap-datepicker</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>Bootstrap Notify</b></CardSubtitle>
                <p>
                  Turns standard Bootstrap alerts into "Growl-like" notifications.
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://github.com/mouse0270/bootstrap-growl">https://github.com/mouse0270/bootstrap-growl</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>Bootstrap Tags Input</b></CardSubtitle>
                <p>
                  jQuery tags input plugin based on Twitter Bootstrap.
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://github.com/bootstrap-tagsinput/bootstrap-tagsinput">https://github.com/bootstrap-tagsinput/bootstrap-tagsinput</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>Chartjs</b></CardSubtitle>
                <p>
                  Simple yet flexible JavaScript charting for designers & developers
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="http://chartjs.org">http://chartjs.org</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>Countdown.js</b></CardSubtitle>
                <p>
                  A little JavaScript cutstomizable countdown
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://github.com/HugoGiraudel/Countdown.js">https://github.com/HugoGiraudel/Countdown.js</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>Cropperjs</b></CardSubtitle>
                <p>
                  JavaScript image cropper.
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://fengyuanchen.github.io/cropperjs">https://fengyuanchen.github.io/cropperjs</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>Datatables</b></CardSubtitle>
                <p>
                  Add advanced interaction controls to your HTML tables
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://datatables.net">https://datatables.net</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>Dropzonejs</b></CardSubtitle>
                <p>
                  Open source library that provides drag’n’drop file uploads with image previews.
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://www.dropzonejs.com/">https://www.dropzonejs.com</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>Fullcalendar</b></CardSubtitle>
                <p>
                  The most popular full-sized JavaScript Calendar.
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://fullcalendar.io/">https://fullcalendar.io</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>Glidejs</b></CardSubtitle>
                <p>
                  A dependency-free JavaScript ES6 slider and carousel. It’s lightweight, flexible and fast.
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://github.com/glidejs/glide">https://github.com/glidejs/glide</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>jQuery Autoellipsis</b></CardSubtitle>
                <p>
                  Auto-ellipsis plugin for jQuery
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://github.com/pvdspek/jquery.autoellipsis">https://github.com/pvdspek/jquery.autoellipsis</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>jQuery Bar Rating</b></CardSubtitle>
                <p>
                  jQuery Bar Rating Plugin - minimal, light-weight jQuery ratings.
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://github.com/antennaio/jquery-bar-rating">https://github.com/antennaio/jquery-bar-rating</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>jQuery ContextMenu</b></CardSubtitle>
                <p>
                  jQuery contextMenu plugin & polyfill.
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://github.com/swisnl/jQuery-contextMenu">https://github.com/swisnl/jQuery-contextMenu</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>Smart Wizard</b></CardSubtitle>
                <p>
                  The awesome jQuery step wizard plugin with Bootstrap support
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://github.com/techlab/SmartWizard">https://github.com/techlab/SmartWizard</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>Momentjs</b></CardSubtitle>
                <p>
                  Parse, validate, manipulate, and display dates in javascript.
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://github.com/moment/moment/">https://github.com/moment/moment</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>Mousetrap</b></CardSubtitle>
                <p>
                  Simple library for handling keyboard shortcuts in Javascript
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://github.com/ccampbell/mousetrap">https://github.com/ccampbell/mousetrap</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>NoUiSlider</b></CardSubtitle>
                <p>
                  A lightweight JavaScript range slider library with full multi-touch support.
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://github.com/leongersen/noUiSlider">https://github.com/leongersen/noUiSlider</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>Perfect Scrollbar</b></CardSubtitle>
                <p>
                  Minimalistic but perfect custom scrollbar plugin.
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://github.com/mdbootstrap/perfect-scrollbar">https://github.com/mdbootstrap/perfect-scrollbar</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>Progressbar.js</b></CardSubtitle>
                <p>
                  Responsive and slick progress bars.
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://github.com/kimmobrunfeldt/progressbar.js">https://github.com/kimmobrunfeldt/progressbar.js</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>Quilljs</b></CardSubtitle>
                <p>
                  Quill is a modern WYSIWYG editor built for compatibility and extensibility.
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://github.com/quilljs/quill">https://github.com/quilljs/quill</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>Select2</b></CardSubtitle>
                <p>
                  Select2 is a jQuery based replacement for select boxes. It supports searching, remote data sets, and infinite scrolling of results.
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://github.com/select2/select2">https://github.com/select2/select2</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>Sortable</b></CardSubtitle>
                <p>
                  Sortable is a JavaScript library for reorderable drag-and-drop lists on modern browsers and touch devices.
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://github.com/SortableJS/Sortable">https://github.com/SortableJS/Sortable</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>Typeahead</b></CardSubtitle>
                <p>
                  The Typeahead plugin from Twitter's Bootstrap 2 ready to use with Bootstrap 3 and Bootstrap 4
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://github.com/bassjobsen/Bootstrap-3-Typeahead">https://github.com/bassjobsen/Bootstrap-3-Typeahead</a>
                </p>
                <br />
                <br />

                <CardSubtitle><b>Video.js</b></CardSubtitle>
                <p>
                  Video.js - open source HTML5 & Flash video player
                </p>
                <p>
                  <a className="btn-link" target="_blank" rel="noopener noreferrer" href="https://github.com/videojs/video.js">https://github.com/videojs/video.js</a>
                </p>
         
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    )
  }
}
